import { render, staticRenderFns } from "./documents-index.vue?vue&type=template&id=84a88a28"
import script from "./documents-index.vue?vue&type=script&lang=js"
export * from "./documents-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports